// extracted by mini-css-extract-plugin
export default {"titleWrapper":"SearchComponentUI_titleWrapper__6ly9U","titleText":"SearchComponentUI_titleText__YizIw","item":"SearchComponentUI_item__cicNr"};